import React from "react";
import notify from "devextreme/ui/notify";
import Form, { SimpleItem, GroupItem, Label } from "devextreme-react/form";
import "devextreme-react/text-area";
import { criarTipoPessoaDs, criarMunicipioDs } from "../../DataSources";
import { Button } from "devextreme-react";
import UserInfo from "../../UserInfo";
import { inserirOuAtualizar, criarContadorDs } from "../../DataSources";
import ShowError from "../../AppServices";

const senhaOptions = {
  mode: "password",
};

const tipoUsuarioOptions = {
  editorType: "dxSelectBox",
  dataSource: criarTipoPessoaDs(),
  valueExpr: "Id",
  displayExpr: "Id",
};

let _contadorCorrente;

const template = {
  id: undefined,
  prefeituraId: undefined,
  nome: "",
  senha: "",
  tipoUsuario: "PF",
  documento: "",
  dataCriacao: new Date(),
  usuarioBloqueado: false,
  usuarioAtivo: true,
  usuarioTipo: "CONTADOR",
  crc: "",
  rg: "",
  orgaoExpedidor: "",
  ufrg: "",
  email: "",
  telefone: "",
  celular: "",
  logradouro: "",
  numeroEndereco: "",
  complemento: "",
  bairro: "",
  pais: "Brasil",
  estadoId: 23,
  estadoEndereco: "CEARA",
  municipioId: undefined,
  municipio: "",
  cep: "",
  tipoEndereco: "NACIONAL",
  motivoBloqueio: "",
  motivoDesativacao: "",
};

export default class ContadorForm extends React.Component {
  constructor(props) {
    super(props);

    template.municipioId = UserInfo.getMunicipioId();
    this.state = {};
    this.contadorDs = criarContadorDs();

    this.ok = this.ok.bind(this);
    this.cancel = this.cancel.bind(this);
    this.saidaProgramada = false;

    this.municipioOptions = {
      editorType: "dxSelectBox",
      searchEnabled: true,
      dataSource: criarMunicipioDs(),
      valueExpr: "id",
      displayExpr: "nomeCompleto",
      searchExpr: ["nome", "estado"],
      searchMode: "contains",
    };
  }

  componentDidMount() {
    if (this.props.match.params.id !== undefined) {
      this.contadorDs
        .byKey(this.props.match.params.id)
        .then((data) => {
          if (data == undefined) {
            notify("Registro não encontrado.", "error");
            this.props.history.push("/contadores");
          }
          this.setState(data);
        })
        .catch((error) => {
          ShowError(error.response.data);
          notify(error, "error", 2000);
          this.props.history.goBack();
        });
    }
    if (this.props.match.params.id === undefined) {
      this.setState({ ...template });
    }
  }

  showMotivoBloqueio() {
    if (this.state.usuarioBloqueado) {
      return (
        <SimpleItem
          colSpan={2}
          dataField={"MotivoBloqueio"}
          editorType={"dxTextArea"}
        />
      );
    }
  }

  render() {
    return (
      <React.Fragment>
        <div className={"content-block dx-card responsive-paddings"}>
          <Form formData={this.state} colCount={2}>
            <GroupItem
              caption="INFORMAÇÕES DO USUÁRIO"
              colSpan={2}
              colCount={2}
            >
              <SimpleItem dataField={"nome"} />
              <SimpleItem dataField={"documento"}>
                <Label text="CPF/CNPJ" />
              </SimpleItem>
              <SimpleItem
                dataField={"senha"}
                editorType={"dxTextBox"}
                editorOptions={senhaOptions}
              />
              <SimpleItem
                dataField={"tipoUsuario"}
                editorType={"dxSelectBox"}
                editorOptions={tipoUsuarioOptions}
              >
                <Label text="Tipo de Pessoa" />
              </SimpleItem>
              <SimpleItem
                dataField={"dataCriacao"}
                editorType={"dxDateBox"}
                editorOptions={{ type: "date", readOnly: true }}
              >
                <Label text="Data de Criação" />
              </SimpleItem>
              <SimpleItem
                dataField={"usuarioBloqueado"}
                editorType={"dxCheckBox"}
              >
                <Label text="bloqueado" />
              </SimpleItem>
              <SimpleItem
                dataField={"usuarioAtivo"}
                editorType={"dxCheckBox"}
              />
            </GroupItem>

            <GroupItem caption="CRC" colCount={2}>
              <SimpleItem dataField={"crc"}>
                <Label text="CRC" />
              </SimpleItem>
            </GroupItem>
            <GroupItem caption="RG" colCount={2}>
              <SimpleItem dataField={"rg"} caption="Número">
                <Label text="Número" />
              </SimpleItem>
              <SimpleItem dataField={"orgaoExpedidor"} caption="Orgão">
                <Label text="Orgão" />
              </SimpleItem>
              <SimpleItem dataField={"ufrg"} caption="UF">
                <Label text="UF" />
              </SimpleItem>
            </GroupItem>

            <GroupItem
              caption="INFORMAÇÕES DE CONTATO"
              colCount={2}
              colSpan={2}
            >
              <SimpleItem dataField={"email"} colSpan={2}>
                <Label text="E-mail" />
              </SimpleItem>
              <SimpleItem dataField={"telefone"} />
              <SimpleItem dataField={"celular"} />
            </GroupItem>
            <GroupItem caption="ENDEREÇO" colCount={2} colSpan={2}>
              <SimpleItem dataField={"cep"} />
              <SimpleItem dataField={"logradouro"} />
              <SimpleItem dataField={"numeroEndereco"}>
                <Label text="N.º" />
              </SimpleItem>
              <SimpleItem dataField={"complemento"} />
              <SimpleItem dataField={"bairro"} />
              <SimpleItem dataField={"pais"}>
                <Label text="País" />
              </SimpleItem>
              <SimpleItem
                dataField={"municipioId"}
                editorType={"dxLookup"}
                editorOptions={this.municipioOptions}
              >
                <Label text="Município" />
              </SimpleItem>
            </GroupItem>
            {this.showMotivoBloqueio()}
          </Form>
          <br />
          <div
            style={{
              marginTop: "10px",
              display: "flex",
              justifyContent: "center",
            }}
          >
            <div style={{ display: "inline-block" }}>
              <Button
                width={150}
                text="Salvar"
                type="success"
                onClick={this.ok}
              />
            </div>
            <div style={{ display: "inline-block", marginLeft: "10px" }}>
              <Button text="Cancelar" width={150} onClick={this.cancel} />
            </div>
          </div>
        </div>
      </React.Fragment>
    );
  }

  ok() {
    const contador = this.state;
    contador.prefeituraId = UserInfo.getPrefeitura();
    inserirOuAtualizar(this.contadorDs, contador)
      .then(
        function () {
          _contadorCorrente = undefined;
          notify("Contador cadastrado com sucesso.", "success");
          this.props.history.goBack();
        }.bind(this)
      )
      .catch((error) => {
        ShowError(error.response.data);
        notify(error, "error", 2000);
      });
  }

  cancel() {
    _contadorCorrente = undefined;
    notify("Operação cancelada", "warning");
    this.props.history.goBack();
  }
}
